"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m14.2999 3.6385-5 3.5L8.1529 5.5 13.153 2l1.1469 1.6385zm5.943 3.2536-3.4966 5.0024-1.6393-1.1458 3.4966-5.0024 1.6393 1.1458zm-1.0911 11.2592 2.9353-5.3511-1.7535-.9619-2.9353 5.3511 1.7535.9619zm-6.2242-9.4621 1.0469 6.4924L12 15.5l-1.0469-6.4924 1.9745-.3184zm-1.7353 13.4489 4.669-3.2462-1.1417-1.6421-4.669 3.2462 1.1417 1.6421zM4.4528 7.1445l4.1945 4.4336-1.4528 1.3745L3 8.519l1.4528-1.3745zm4.7736 8.1747h-6v2h6v-2z"
  })];
};

exports.default = _default;